<template>
    <v-dialog v-model="dialogOpen" max-width="700px" height="500px">
        <v-card>

            <material-header
                    title="Select widgets"
                    toolbar-color="grey darken-4"
                    :dense="true"
                    icon="mdi-ballot">

                <template slot="buttons">
                    <v-btn icon text @click="closeDialog()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </template>

            </material-header>

            <v-container fluid>
                <v-row dense>
                    <template v-for="(component,index) in widgets">
                        <v-col cols="6" v-if="hasPermission(component.permission)" :key="index">
                            <v-card color="grey darken-2">
                                <v-card-text class="pt-1 pb-5">
                                    <v-checkbox
                                            color="primary"
                                            @change="widgetToggle(component)"
                                            v-model="component.active"
                                            :label="component.title"
                                            hide-details
                                    ></v-checkbox>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </template>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>

    import MaterialHeader from '../../../components/UI/MaterialHeader';
    import {mapState, mapMutations, mapGetters, mapActions} from 'vuex';

    export default {

        components: {
            MaterialHeader
        },

        props: {
            value: {
                type: Boolean,
                default: false,
                required: false
            },
        },

        computed: {

            ...mapState('DashBoard', [
                'widgets'
            ]),

            dialogOpen: {
                get() {
                    return this.value;
                },
                set() {
                    this.closeDialog();
                }
            }
        },

        methods: {
            widgetToggle(widget) {
                this.$emit('change', widget);
            },

            closeDialog() {
                this.$emit('input', false);
            },
        }
    }
</script>
